import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
} from '@wegroup/design-system';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { handleResponseLanguage } from '../../../../../../../../../../i18n';
import { CalculationSpec } from '../../../../../../../../../../types/Quotes';

interface Props {
  calculationSpec: CalculationSpec;
}

const DefaultInput: React.FC<Props> = ({ calculationSpec }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = errors[calculationSpec.calc_type]?.message;

  return (
    <FormControl isInvalid={!!errors[calculationSpec.calc_type]}>
      <FormLabel>{handleResponseLanguage(calculationSpec.title)}</FormLabel>
      <Input
        {...register(calculationSpec.calc_type)}
        isDisabled={calculationSpec.disabled || !calculationSpec.calc_type}
      />
      {error && <FormErrorMessage>{t(error as string)}</FormErrorMessage>}
    </FormControl>
  );
};

export default DefaultInput;
